import React from 'react';
import ReactDOM from 'react-dom';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import './index.css';
import App from './app';

declare global {
    interface Window {
        APP_VARS: any;
    }
}

const env = window.APP_VARS.REACT_APP_APP_ENV || 'production';
const gitSHA = process.env.REACT_APP_GIT_SHA || 'v1.0';

const datadogClientToken = 'pubfc8f9e7d7bd8d2a790319ba20d794369';
const datadogApplicationId = '6ddf4de3-3e0a-4e27-85f8-1ac203081dfd';
const datadogServiceName = 'progressive-profiling';

if (env !== 'development') {
    datadogRum.init({
        applicationId: datadogApplicationId,
        clientToken: datadogClientToken,
        service: datadogServiceName,
        env,
        version: gitSHA,
        sampleRate: 100,
        trackInteractions: true,
    });

    datadogLogs.init({
        clientToken: datadogClientToken,
        env,
        forwardErrorsToLogs: true,
        sampleRate: 100,
        service: datadogServiceName,
        version: gitSHA,
        silentMultipleInit: true,
    });
}

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
